class PredictiveSearch extends SearchForm {
	constructor() {
		super();

		this.cachedResults = {};

		this.predictiveSearchResults = this.querySelector(
			"[data-predictive-search]"
		);

		this.allPredictiveSearchInstances =
			document.querySelectorAll("predictive-search");

		this.isOpen = false;
		this.abortController = new AbortController();
		this.searchTerm = "";
		this.body = document.querySelector("body");
		this.headerBottom = document.querySelector(".header__bottom");
		this.promoModal = document.querySelector(".search__modal");
		this.headerInput = document.querySelector(".search-modal .search__input");

		this.calcHeight();
		this.setupEventListeners();

		const searchResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;

			if (entry.contentRect.width < 991) {
				this.calcHeight(65);
			} else {
				this.calcHeight(0);
			}
		});

		if (this.body) {
			searchResizeObserver.observe(this.body);
		}
	}

	calcHeight(buttonHeight) {
		let heightHeader = document.querySelector(".shopify-section-header")
			? document
					.querySelector(".shopify-section-header")
					.getBoundingClientRect().height
			: 0;

		let heightSearchTop = document.querySelector(".search__form__wrapper")
			? document
					.querySelector(".search__form__wrapper")
					.getBoundingClientRect().height
			: 0;

		let heightInput = this.headerInput
			? this.headerInput.getBoundingClientRect().height
			: 0;
	}

	setupEventListeners() {
		if (!this.input || !this.input.form) {
			return;
		}

		this.input.form.addEventListener(
			"submit",
			this.onFormSubmit.bind(this)
		);

		this.input.addEventListener(
			"focus",
			this.onFocus.bind(this)
		);

		this.addEventListener(
			"focusout",
			this.onFocusOut.bind(this)
		);

		this.addEventListener(
			"keyup",
			this.onKeyup.bind(this)
		);

		this.addEventListener(
			"keydown",
			this.onKeydown.bind(this)
		);
	}

	getQuery() {
		return this.input.value.trim();
	}

	escapeShopifySearchValue(value) {
		return value
			.replace(/\\/g, "\\\\")
			.replace(/:/g, "\\:")
			.replace(/\(/g, "\\(")
			.replace(/\)/g, "\\)");
	}

	buildMainSearchQuery(searchTerm) {
		const terms = searchTerm
			.trim()
			.split(/\s+/)
			.filter(Boolean)
			.map((term) =>
				this.escapeShopifySearchValue(term)
			);

		if (!terms.length) {
			return "";
		}

		const productTitleQuery = terms
			.map((term) => `title:${term}*`)
			.join(" ");

		const variantTitleQuery = terms
			.map((term) => `variants.title:${term}*`)
			.join(" ");

		return `(${productTitleQuery}) OR (${variantTitleQuery})`;
	}

	onChange() {
		const newSearchTerm = this.getQuery();

		if (
			!this.searchTerm ||
			!newSearchTerm.startsWith(this.searchTerm)
		) {
			this.querySelector(
				"#predictive-search-results-groups-wrapper"
			)?.remove();
		}

		this.updateSearchForTerm(
			this.searchTerm,
			newSearchTerm
		);

		this.searchTerm = newSearchTerm;

		if (!this.searchTerm.length) {
			this.close(true);
			return;
		}

		this.getSearchResults(this.searchTerm);
	}

	onFormSubmit(event) {
		const searchTerm = this.getQuery();

		if (!searchTerm.length) {
			event.preventDefault();
			return;
		}

		if (
			this.querySelector('[aria-selected="true"] a') ||
			event.submitter?.classList.contains("card__link")
		) {
			event.preventDefault();
			return;
		}

		event.preventDefault();

		const searchQuery =
			this.buildMainSearchQuery(searchTerm);

		if (!searchQuery) {
			return;
		}

		sessionStorage.setItem(
			"mainSearchOriginalTerm",
			searchTerm
		);

		const destination = new URL(
			this.input.form.action || "/search",
			window.location.origin
		);

		destination.searchParams.set(
			"q",
			searchQuery
		);

		destination.searchParams.set(
			"options[prefix]",
			"none"
		);

		destination.searchParams.set(
			"sort_by",
			"relevance"
		);

		window.location.href =
			destination.pathname +
			destination.search;
	}

	onFormReset(event) {
		super.onFormReset(event);

		if (super.shouldResetForm()) {
			this.searchTerm = "";

			this.abortController.abort();
			this.abortController = new AbortController();

			this.closeResults(true);
		}
	}

	onFocus() {
		const currentSearchTerm = this.getQuery();

		if (this.classList.contains("search-modal__form")) {
			if (this.headerBottom) {
				this.headerBottom.classList.add(
					"header__bottom--visible"
				);
			}

			if (this.promoModal) {
				this.promoModal.classList.remove(
					"search__modal--hidden"
				);
			}
		}

		if (!currentSearchTerm.length) {
			return;
		}

		if (this.searchTerm !== currentSearchTerm) {
			this.onChange();
		} else if (
			this.getAttribute("results") === "true"
		) {
			this.open();

			if (this.promoModal) {
				this.promoModal.classList.add(
					"search__modal--hidden"
				);
			}
		} else {
			this.getSearchResults(this.searchTerm);
		}
	}

	onFocusOut() {
		if (
			this.classList.contains("search-modal__form")
		) {
			if (this.headerBottom) {
				this.headerBottom.classList.remove(
					"header__bottom--visible"
				);
			}
		}

		if (
			!this.classList.contains("search-modal__form")
		) {
			setTimeout(() => {
				if (
					!this.contains(document.activeElement)
				) {
					this.close();
				}
			});
		}
	}

	onBlur() {
		if (this.headerInput) {
			this.headerInput.blur();
		}
	}

	onKeyup(event) {
		if (!this.getQuery().length) {
			this.close(true);
		}

		switch (event.code) {
			case "Enter": {
				event.preventDefault();

				const selectedOption =
					this.querySelector(
						'[aria-selected="true"] a, button[aria-selected="true"]'
					);

				if (selectedOption) {
					selectedOption.click();
				} else {
					this.input.form.requestSubmit();
				}

				break;
			}

			case "Escape":
				event.preventDefault();

				this.closeResults(true);

				if (
					this.promoModal &&
					this.classList.contains(
						"search-modal__form"
					)
				) {
					this.promoModal.classList.add(
						"search__modal--hidden"
					);
				}

				break;
		}

		if (this.getQuery().length) {
			this.hidePromoBlock();
		} else {
			this.showPromoBlock();
		}
	}

	onKeydown(event) {
		if (
			event.code === "ArrowUp" ||
			event.code === "ArrowDown"
		) {
			event.preventDefault();
		}
	}

	updateSearchForTerm(previousTerm, newTerm) {
		const searchForTextElement =
			this.querySelector(
				"[data-predictive-search-search-for-text]"
			);

		const currentButtonText =
			searchForTextElement?.innerText;

		if (currentButtonText) {
			if (
				previousTerm &&
				[
					...currentButtonText.matchAll(
						new RegExp(previousTerm, "g")
					)
				].length > 1
			) {
				return;
			}

			const newButtonText =
				currentButtonText.replace(
					previousTerm,
					newTerm
				);

			searchForTextElement.innerText =
				newButtonText;
		}

		if (this.getQuery().length) {
			this.hidePromoBlock();
		} else {
			this.showPromoBlock();
		}
	}

	selectOption() {
		const selectedOption =
			this.querySelector(
				'[aria-selected="true"] a, button[aria-selected="true"]'
			);

		if (selectedOption) {
			selectedOption.click();
		}
	}

	getSearchResults(searchTerm) {
		const queryKey = searchTerm
			.replace(/\s+/g, "-")
			.toLowerCase();

		this.setLiveRegionLoadingState();

		if (this.cachedResults[queryKey]) {
			this.renderSearchResults(
				this.cachedResults[queryKey]
			);

			this.clickSearchTabs();
			this.calcHeight();

			return;
		}

		if (
			this.promoModal &&
			this.classList.contains("search-modal__form")
		) {
			this.promoModal.classList.add(
				"search__modal--hidden"
			);
		}

		this.abortController.abort();
		this.abortController = new AbortController();

		const searchParams = new URLSearchParams();

		searchParams.set(
			"q",
			searchTerm
		);

		searchParams.set(
			"section_id",
			"predictive-search"
		);

		searchParams.set(
			"resources[options][fields]",
			"title,product_type,variants.title,vendor"
		);

		searchParams.set(
			"resources[options][unavailable_products]",
			"last"
		);

		fetch(
			`${routes.predictive_search_url}?${searchParams.toString()}`,
			{
				signal: this.abortController.signal
			}
		)
			.then((response) => {
				if (!response.ok) {
					throw new Error(
						`Predictive search error: ${response.status}`
					);
				}

				return response.text();
			})
			.then((text) => {
				const parsedDocument =
					new DOMParser().parseFromString(
						text,
						"text/html"
					);

				const predictiveSection =
					parsedDocument.querySelector(
						"#shopify-section-predictive-search"
					);

				if (!predictiveSection) {
					this.close();
					return;
				}

				const resultsMarkup =
					predictiveSection.innerHTML;

				this.allPredictiveSearchInstances.forEach(
					(predictiveSearchInstance) => {
						predictiveSearchInstance.cachedResults[
							queryKey
						] = resultsMarkup;
					}
				);

				this.renderSearchResults(
					resultsMarkup
				);

				this.clickSearchTabs();
				this.calcHeight();

				if (
					typeof colorSwatches === "function"
				) {
					colorSwatches();
				}
			})
			.catch((error) => {
				if (
					error?.name === "AbortError" ||
					error?.code === 20
				) {
					return;
				}

				this.close();

				console.error(
					"Predictive search error:",
					error
				);
			});
	}

	setLiveRegionLoadingState() {
		this.statusElement =
			this.statusElement ||
			this.querySelector(
				".predictive-search-status"
			);

		this.loadingText =
			this.loadingText ||
			this.getAttribute(
				"data-loading-text"
			);

		this.setLiveRegionText(
			this.loadingText
		);

		this.setAttribute(
			"loading",
			true
		);
	}

	setLiveRegionText(statusText) {
		if (!this.statusElement) {
			return;
		}

		this.statusElement.setAttribute(
			"aria-hidden",
			"false"
		);

		this.statusElement.textContent =
			statusText;

		setTimeout(() => {
			this.statusElement.setAttribute(
				"aria-hidden",
				"true"
			);
		}, 1000);
	}

	renderSearchResults(resultsMarkup) {
		if (!this.predictiveSearchResults) {
			return;
		}

		this.predictiveSearchResults.innerHTML =
			resultsMarkup;

		this.setAttribute(
			"results",
			true
		);

		this.setLiveRegionResults();
		this.open();

		if (
			this.promoModal &&
			this.classList.contains(
				"search-modal__form"
			)
		) {
			this.promoModal.classList.add(
				"search__modal--hidden"
			);
		}
	}

	clickSearchTabs() {
		const results =
			this.querySelectorAll(
				".predictive-search__results-list"
			);

		if (results.length === 0) {
			return;
		}

		results.forEach((result) => {
			result.classList.remove(
				"active"
			);
		});

		this.querySelectorAll(
			".predictive-search__result-tab"
		).forEach((tab) => {
			tab.classList.remove(
				"active"
			);
		});

		results[0].classList.add(
			"active"
		);

		const firstTab =
			this.querySelector(
				".predictive-search__result-tab"
			);

		if (firstTab) {
			firstTab.classList.add(
				"active"
			);
		}

		this.querySelectorAll(
			".predictive-search__result-tab"
		).forEach((tab) => {
			tab.addEventListener(
				"click",
				(event) => {
					event.preventDefault();

					const typeTarget =
						tab.dataset.typeTarget;

					this.querySelectorAll(
						".predictive-search__result-tab"
					).forEach((element) => {
						element.classList.remove(
							"active"
						);
					});

					tab.classList.add(
						"active"
					);

					results.forEach(
						(element) => {
							const resultsType =
								element.dataset.type;

							if (
								resultsType ===
								typeTarget
							) {
								element.classList.add(
									"active"
								);
							} else {
								element.classList.remove(
									"active"
								);
							}
						}
					);
				}
			);
		});
	}

	hidePromoBlock() {
		const recommendation =
			document.querySelector(
				".search__recomendation"
			);

		const line =
			document.querySelector(
				".search__line"
			);

		if (recommendation) {
			recommendation.classList.add(
				"hidden"
			);
		}

		if (line) {
			line.classList.add(
				"hide"
			);
		}
	}

	showPromoBlock() {
		const recommendation =
			document.querySelector(
				".search__recomendation"
			);

		const line =
			document.querySelector(
				".search__line"
			);

		if (recommendation) {
			recommendation.classList.remove(
				"hidden"
			);
		}

		if (line) {
			line.classList.remove(
				"hide"
			);
		}
	}

	setLiveRegionResults() {
		this.removeAttribute(
			"loading"
		);

		const countElement =
			this.querySelector(
				"[data-predictive-search-live-region-count-value]"
			);

		if (countElement) {
			this.setLiveRegionText(
				countElement.textContent
			);
		}
	}

	open() {
		this.setAttribute(
			"open",
			true
		);

		this.input.setAttribute(
			"aria-expanded",
			true
		);

		this.isOpen = true;

		this.parentElement
			?.parentElement
			?.parentElement
			?.classList.add(
				"predictive-open"
			);

		if (
			this.promoModal &&
			this.classList.contains(
				"search-modal__form"
			)
		) {
			this.promoModal.classList.remove(
				"search__modal--hidden"
			);
		}
	}

	close(clearSearchTerm = false) {
		this.closeResults(
			clearSearchTerm
		);

		this.parentElement
			?.parentElement
			?.parentElement
			?.classList.remove(
				"predictive-open"
			);

		this.isOpen = false;
	}

	closeResults(clearSearchTerm = false) {
		if (clearSearchTerm) {
			this.input.value = "";

			this.removeAttribute(
				"results"
			);
		}

		const selected =
			this.querySelector(
				'[aria-selected="true"]'
			);

		if (selected) {
			selected.setAttribute(
				"aria-selected",
				"false"
			);
		}

		this.input.setAttribute(
			"aria-activedescendant",
			""
		);

		this.removeAttribute(
			"loading"
		);

		this.removeAttribute(
			"open"
		);

		this.input.setAttribute(
			"aria-expanded",
			false
		);

		if (this.predictiveSearchResults) {
			this.predictiveSearchResults.removeAttribute(
				"style"
			);
		}

		if (this.promoModal) {
			this.promoModal.classList.add(
				"search__modal--hidden"
			);
		}
	}
}

customElements.define(
	"predictive-search",
	PredictiveSearch
);